import type { FaireProductEntity } from "../../entity_types/product";

export const p_4evbh2u986: FaireProductEntity = {
  token: "p_4evbh2u986",
  type: "product",
  name: "Arkansas Razorback Earrings",
  brandToken: "b_kqfv9z6tvp",
  brandName: "Cora's Den",
  imageUrl:
    "https://cdn.faire.com/fastly/734cc0fe994290384e169798b3a82a2fa83ed78e57bb7cd8b64a3ad0100e2a71.jpeg",
  galleryImageUrls: [],
  priceDollars: 10,
  description:
    "Woo Pig Sooie!!! These Razorback accessories are the perfect thing to call those Hogs in! Need something custom for gameday? Just send us a message and our team is ready to help you with that as well.",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:25:55.062Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
